import React from 'react';
import { CreditCard } from '@phosphor-icons/react';

import { ModalForm } from '../../design-system/patterns/modal-form';
import { Icon } from '../../design-system/components/Icon';

/**
 * The last confirmation before the order is placed and the buyer is handed to
 * the payment provider.
 *
 * The 60-line inline SVG that used to sit here went with the gradient it was
 * painted in: four `linearGradient` defs hardcoding `#2465EA` to `#08B0D5`,
 * which is the cyan this conversion is removing rather than restyling. The
 * glyph is now a Phosphor icon on `currentColor`.
 *
 * THE CARD SITS ON THE TITLE'S LEFT, not above the copy. It was a lone glyph in
 * its own paragraph at the top of the body, which on a 390px sheet reads as an
 * orphan: a big card floating under a header it belongs to, pushing the one
 * sentence that matters further from the thumb. `ModalForm`'s `titleIcon` puts
 * it where it is actually saying something -- beside the words "Proceed to
 * payment" -- on both tracks.
 *
 * MODAL ON DESKTOP, SHEET ON A PHONE, which is what `ModalForm` resolves. This
 * was a bare `Modal` on both tracks, so the commit moment of the whole app —
 * the one dialog that spends the buyer's money — was a 342px box floating in
 * the middle of a 390px screen with a right-aligned row of 40px buttons, while
 * every other dismissable surface on that track is a bottom sheet. The pattern
 * states the rule and the reason (modal-form/index.jsx:51): a `Modal` portals
 * to `<body>`; a `Sheet` is anchored to the bottom of the shell, so its CTAs
 * are full width and closest to the thumb.
 *
 * The prop API is unchanged so `Checkout.jsx` is untouched by the swap.
 */
const ProceedPaymentModal = ({ isOpen, onClose, onProceed, isProcessing }) => (
  <ModalForm
    open={isOpen}
    onClose={onClose}
    title="Proceed to payment"
    /* These handlers take no arguments; `ModalForm` submits a real form and
       would otherwise hand them the event. */
    onSubmit={() => onProceed && onProceed()}
    submitLabel="Proceed"
    submittingLabel="Processing"
    submitting={isProcessing}
    cancelLabel="Cancel"
    titleIcon={<Icon as={CreditCard} size="lg" />}
  >
    <p>You are being taken to the secure payment page to complete this order.</p>
  </ModalForm>
);

export default ProceedPaymentModal;
